import { UserSession } from '@/app/models/interface/user.session';
import { Component, input, model, output, signal } from '@angular/core';

type ModalStep = 'verify' | 'sessions';

@Component({
  selector: 'c-session-modal',
  standalone: false,
  templateUrl: './session-modal.component.html',
  styleUrl: './session-modal.component.css',
})
export class SessionModalComponent {
  sessions = input.required<UserSession[]>();

  dobleFactorActivado = input.required();

  modalOpen = signal<boolean>(false);

  step = model<ModalStep>('verify');

  requestCode = signal<boolean>(false);

  openModal(): void {
    this.modalOpen.set(true);

    if (this.dobleFactorActivado()) {
      this.step.set('verify');
      this.requestCode.set(true);
    } else {
      this.step.set('sessions');
    }
  }

  verifiedSuccess(): void {
    this.step.set('sessions');
    this.requestCode.set(false);
  }

  closeModal(): void {
    this.modalOpen.set(false);
  }

  deviceIcon(type: UserSession['deviceType']): string {
    switch (type) {
      case 'mobile':
        return '▯';

      case 'tablet':
        return '▣';

      default:
        return '▰';
    }
  }

  currentSessionId = input<string | null>(null);

  revokeSession = output<string>();

  closeSession(refreshTokenHash: string): void {
    this.revokeSession.emit(refreshTokenHash);
  }
}
